document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initContadores();
  initParallax();
  initMarquesina();
});

function initReveal() {
  var els = document.querySelectorAll('.zv-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('zv-visible'); });
    return;
  }
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry, i) {
      if (entry.isIntersecting) {
        var delay = entry.target.getAttribute('data-zv-delay') || 0;
        setTimeout(function () { entry.target.classList.add('zv-visible'); }, Number(delay));
        obs.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { obs.observe(el); });
}

function initContadores() {
  var els = document.querySelectorAll('[data-zv-contador]');
  if (!els.length || !('IntersectionObserver' in window)) return;
  var obs = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      obs.unobserve(el);
      var final = el.getAttribute('data-zv-contador');
      var match = final.match(/^([\d.,]+)(.*)$/);
      if (!match) { el.textContent = final; return; }
      var numStr = match[1].replace(',', '.');
      var suffix = match[2] || '';
      var target = parseFloat(numStr);
      if (isNaN(target)) { el.textContent = final; return; }
      var decimals = (numStr.split('.')[1] || '').length;
      var duration = 1200;
      var start = null;
      function paso(ts) {
        if (!start) start = ts;
        var progreso = Math.min((ts - start) / duration, 1);
        var eased = 1 - Math.pow(1 - progreso, 3);
        var valor = (target * eased).toFixed(decimals);
        el.textContent = valor.replace('.', ',') + suffix;
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = numStr.replace('.', ',') + suffix;
      }
      requestAnimationFrame(paso);
    });
  }, { threshold: 0.4 });
  els.forEach(function (el) { obs.observe(el); });
}

function initParallax() {
  var els = document.querySelectorAll('[data-zv-parallax]');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var ticking = false;
  function actualizar() {
    els.forEach(function (el) {
      var intensidad = Number(el.getAttribute('data-zv-parallax')) || 20;
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight || 1;
      var progreso = (rect.top / vh);
      var desplazamiento = progreso * intensidad;
      el.style.transform = 'translateY(' + desplazamiento.toFixed(1) + 'px)';
    });
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { window.requestAnimationFrame(actualizar); ticking = true; }
  }, { passive: true });
  actualizar();
}

function initMarquesina() {
  var pistas = document.querySelectorAll('[data-zv-marquesina]');
  if (!pistas.length) return;
  pistas.forEach(function (pista) {
    if (pista.dataset.zvClonado) return;
    pista.dataset.zvClonado = '1';
    var clon = pista.innerHTML;
    pista.insertAdjacentHTML('beforeend', clon);
  });
}
